export default __webpack_public_path__ + "static/media/coin_2gms.5b3d9df8.jpg";